export default __webpack_public_path__ + "media/images/manual/joanr/04-0c4d8669f234d90542c0bdf05a0e3b54.png";